export default __webpack_public_path__ + "static/media/chrysanthemum.4fd1a487.png";